var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRitirataBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61 53",
    style: {
      enableBackground: "new 0 0 61 53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M28.9,42.4c-0.4,0-0.8-0.2-0.9-0.6L15.7,4.2L6.6,2.8c-0.5,0-0.9-0.5-0.8-1C5.9,1.3,6.4,0.9,6.9,1l9.7,1.5 c0.3,0.1,0.6,0.3,0.7,0.6l12.4,38.1c0.2,0.5-0.1,1-0.6,1.2C29.1,42.4,29,42.4,28.9,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M35.1,46c-0.4,0-0.8-0.2-0.9-0.6c-0.2-0.5,0.1-1,0.6-1.2l23-7.5c0.5-0.2,1,0.1,1.2,0.6s-0.1,1-0.6,1.2l-23,7.5 C35.3,46,35.2,46,35.1,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M54.6,36.2c-0.4,0-0.8-0.2-0.9-0.6l-6.1-18.7l-20.8,6.8c-0.5,0.2-1-0.1-1.2-0.6s0.1-1,0.6-1.2l21.7-7.1 c0.5-0.2,1,0.1,1.2,0.6L55.5,35c0.2,0.5-0.1,1-0.6,1.2C54.8,36.2,54.7,36.2,54.6,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M43.3,17.7c-0.4,0-0.8-0.2-0.9-0.6L37.9,3.3L21.7,8.6c-0.5,0.2-1-0.1-1.2-0.6s0.1-1,0.6-1.2l17.1-5.6 c0.2-0.1,0.5-0.1,0.7,0.1c0.2,0.1,0.4,0.3,0.5,0.5l4.8,14.6c0.2,0.5-0.1,1-0.6,1.2C43.5,17.7,43.4,17.7,43.3,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M34.2,25.5c-0.1,0-0.3,0-0.4-0.1c-0.2-0.1-0.4-0.3-0.5-0.5l-1.3-4c-0.2-0.5,0.1-1,0.6-1.2s1,0.1,1.2,0.6l1,3 l7.1-2.3l-1-3c-0.2-0.5,0.1-1,0.6-1.2s1,0.1,1.2,0.6l1.3,3.9c0.1,0.2,0.1,0.5-0.1,0.7c-0.1,0.2-0.3,0.4-0.5,0.5l-8.9,2.9 C34.4,25.4,34.3,25.5,34.2,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M27.8,10.4c-0.4,0-0.8-0.2-0.9-0.6L26,7c-0.2-0.5,0.1-1,0.6-1.2s1,0.1,1.2,0.6l0.6,1.9l4.7-1.5l-0.6-1.9 c-0.2-0.5,0.1-1,0.6-1.2s1,0.1,1.2,0.6l0.9,2.8c0.2,0.5-0.1,1-0.6,1.2l-6.5,2.1C28,10.4,27.9,10.4,27.8,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M30.5,52.1c-0.9,0-1.7-0.2-2.5-0.6c-1.3-0.7-2.3-1.8-2.8-3.2s-0.3-2.9,0.3-4.2c0.7-1.3,1.8-2.3,3.2-2.8 c2.9-1,6.1,0.6,7,3.6l0,0c1,2.9-0.6,6.1-3.6,7C31.7,52,31.1,52.1,30.5,52.1z M30.5,42.9c-0.4,0-0.8,0.1-1.1,0.2 c-0.9,0.3-1.7,1-2.2,1.8c-0.4,0.9-0.5,1.9-0.2,2.8c0.3,0.9,1,1.7,1.8,2.2c0.9,0.4,1.9,0.5,2.8,0.2c1.9-0.6,3-2.7,2.4-4.7l0,0 C33.5,43.9,32.1,42.9,30.5,42.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.7,
    y: 35.7,
    transform: "matrix(0.9507 -0.31 0.31 0.9507 -9.0926 16.1134)",
    className: "st0icon",
    width: 2.9,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.6,
    y: 14.1,
    transform: "matrix(0.9507 -0.31 0.31 0.9507 -2.7875 12.5343)",
    className: "st0icon",
    width: 2.9,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6,
    y: 34.5,
    transform: "matrix(0.9507 -0.31 0.31 0.9507 -8.5188 17.2646)",
    className: "st0icon",
    width: 2.9,
    height: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M10.8,20.5H5.2c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h5.6c0.5,0,0.9,0.4,0.9,0.9 C11.7,20.1,11.3,20.5,10.8,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M17,27H8.6c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9H17c0.5,0,0.9,0.4,0.9,0.9S17.5,27,17,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0icon",
    d: "M15.5,34H2.1c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h13.4c0.5,0,0.9,0.4,0.9,0.9S16,34,15.5,34z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRitirataBlu);
export default __webpack_public_path__ + "static/media/ritirataBlu.859882a7.svg";
export { ForwardRef as ReactComponent };